import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-users-filter',
  templateUrl: './users-filter.component.html',
  styleUrls: ['./users-filter.component.scss'],
  standalone: false,
})
export class UsersFilterComponent {
  @Input() filterData;
  @Input() isOneUserDisplay;

  public onChangeRegions(regions) {
    this.filterData.onChangeRegions(regions);
  }

  public onChangeBranches(branches) {
    this.filterData.onChangeBranches(branches);
  }

  public onChangeSectors(sectors) {
    this.filterData.onChangeSectors(sectors);
  }

  public onChangeCompanies(companies) {
    this.filterData.onChangeCompanies(companies);
  }

  public onChangeUserStatus(status) {
    this.filterData.selected.statusSelected = status ? status : null;
    this.filterData.params.employee_status = status ? status.es_id : '';
  }

  public onChangeRoles(roles) {
    this.filterData.onChangeRoles(roles);
  }
}
